import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../../services/auth.service';
import { User } from 'src/app/shared/models/user';
import { RoleService } from '../../../../services/user-role.service';
import { UserService } from '../../../../services/user.service';
import { Role } from '../../../../models/user-role';
import { ProjectService } from '../../../../services/project.service';
import { Project } from '../../../../models/project';

@Component({
	selector: 'app-project-selector',
	templateUrl: './project-selector.component.html',
	styleUrls: ['./project-selector.component.scss']
})
export class ProjectSelectorComponent implements OnInit {
	public currentUser: User = {};
	public currentUserRole: Partial<Role> = {
		name: null,
		access: []
	};
	public user = JSON.parse(localStorage.getItem('user'));
	isDropdownOpen = false;
	public projects: Project[] = [];
	public selectedProject: Project = null;
	constructor(
		public router: Router,
		private el: ElementRef,
		private projectService: ProjectService,
		private authService: AuthService,
		public userService: UserService,
		private roleService: RoleService
	) {}

	ngOnInit() {
		this.currentUser = this.userService.getCurrentUserInfos();
		if (!['Owner', 'Admin', 'SuperAdmin'].includes(this.currentUser.roles[0])) {
			if ((this.currentUser?.userRole?.role as Role)?._id) {
				this.currentUserRole = this.currentUser?.userRole?.role as Role;
			}
		}
		this.getProjects();
	}
	private getProjects() {
		this.projectService.find(false, false, false, null, null, 'sidebar', null, 'find projects').subscribe(
			res => {
				this.projects = res.filter(project => {
					const hasAccessToComponents = this.currentUserRole.access.some(
						access =>
							access.project === project._id &&
							access.componentAccess.some(componentAccess => componentAccess?.isActive)
					);
					if (!hasAccessToComponents && !this.roleService.hasOwnerAccess()) return false;
					return true;
				});
				this.projectService.projects.next(this.projects);
				this.selectedProject = this.projectService.getCurrentProject();
				if (!this.selectedProject) {
					this.changeProject(this.projects[0]?._id);
				}
			},
			err => {
				console.log(err.message);
			}
		);
	}
	toggleDropdown() {
		if (this.projects?.length > 1) {
			this.isDropdownOpen = !this.isDropdownOpen;
		}
	}
	changeProject(event: any) {
		if (this.projects.length) {
			this.selectedProject = this.projects.find(p => p?._id === event);
			this.projectService.setCurrentProject(this.selectedProject);
		}
		this.isDropdownOpen = false;
	}
	@HostListener('document:click', ['$event'])
	onClickOutside(event: MouseEvent) {
		if (!this.el.nativeElement.contains(event.target)) {
			this.isDropdownOpen = false;
		}
	}
}
